import "@fontsource/noto-serif-jp"
import "./src/styles/foundation/variable.css"
import "./src/styles/foundation/normalize.css"
import "./src/styles/foundation/base.css"
import "./src/styles/foundation/blog-contents-style.css"
import json from "./src/siteData.json"

const articleListSlug = (json.pageConstruct.find(page => page.type === 4) || {})
  .slug

const isArticleList = pathname => {
  if (!articleListSlug || typeof pathname !== "string") return false
  const pattern = new RegExp(
    `^/${articleListSlug}/(c/[^/]+/)?p/\\d+/?$`
  )
  return pattern.test(decodeURIComponent(pathname))
}

export const shouldUpdateScroll = ({ routerProps, prevRouterProps }) => {
  const next = routerProps && routerProps.location && routerProps.location.pathname
  const prev =
    prevRouterProps && prevRouterProps.location && prevRouterProps.location.pathname
  if (isArticleList(prev) && isArticleList(next)) return false
  return true
}
